/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PolygonCoordinateDTO } from './PolygonCoordinateDTO';
import {
    PolygonCoordinateDTOFromJSON,
    PolygonCoordinateDTOFromJSONTyped,
    PolygonCoordinateDTOToJSON,
} from './PolygonCoordinateDTO';

/**
 * 
 * @export
 * @interface PrefabDTO
 */
export interface PrefabDTO {
    /**
     * 
     * @type {boolean}
     * @memberof PrefabDTO
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PrefabDTO
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrefabDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PrefabDTO
     */
    name?: string;
    /**
     * 
     * @type {Array<PolygonCoordinateDTO>}
     * @memberof PrefabDTO
     */
    polygons?: Array<PolygonCoordinateDTO>;
}

/**
 * Check if a given object implements the PrefabDTO interface.
 */
export function instanceOfPrefabDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrefabDTOFromJSON(json: any): PrefabDTO {
    return PrefabDTOFromJSONTyped(json, false);
}

export function PrefabDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrefabDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'polygons': !exists(json, 'polygons') ? undefined : ((json['polygons'] as Array<any>).map(PolygonCoordinateDTOFromJSON)),
    };
}

export function PrefabDTOToJSON(value?: PrefabDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'companyId': value.companyId,
        'id': value.id,
        'name': value.name,
        'polygons': value.polygons === undefined ? undefined : ((value.polygons as Array<any>).map(PolygonCoordinateDTOToJSON)),
    };
}

